import styled from "styled-components";

interface styleProps extends Partial<CSSStyleDeclaration>{
}

export const DisclaimerBoxWrapper = styled.div<styleProps>`   
   padding: 8px;
   background: ${props => (props.backgroundColor)};
   .ant-row{
      flex-flow: nowrap;
   }
`;

